// Third Party Imports
import React from 'react';

// Relative Imports
import DialogBox from '../DialogBox';
import AlertBox from '../Alert/Alert';
import introductionImage1 from '../../images/intro_img1.svg';
import introductionImage2 from '../../images/intro_img2.svg';
import './Introduction.less';
import {getIntroductionContents} from '../utils/introductionPageUtil';

export default class Introduction extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.props.triggerEdapPageViewAction();
    }

    render() {
        const {userType, translations, serviceError, firstName, handleSubmit, handleAlertDismiss, siteName, disableContinueButton, isSWSv2FlowEnabled} = this.props;
        const introductionContents = getIntroductionContents(userType, translations, firstName, siteName, isSWSv2FlowEnabled);

        return (
            <div id="introduction" className="introduction-pg">
                {
                    serviceError
                        ? <div className="alert-container">
                            <div className="alert-wrapper">
                                <div className="alert-panel">
                                    <AlertBox
                                        messageKey={serviceError}
                                        translations={translations}
                                        handleAlertDismiss={handleAlertDismiss}
                                    />
                                </div>
                            </div>
                        </div>
                        : null
                }
                <div className="intro-page-wrapper">
                    <div className="overlay"/>
                    <img className="intro-pg-img intro-pg-img-1" src={introductionImage1()}/>
                    <img className="intro-pg-img intro-pg-img-2" src={introductionImage2()}/>
                    <DialogBox
                        handleSubmit={handleSubmit}
                        styles={introductionContents.styles}
                        actionLabel={translations['ipmob.continue']}
                        contents={introductionContents.contents}
                        dialogHeading={introductionContents.dialogHeading}
                        heading={introductionContents.heading}
                        headingDesc={introductionContents.headingDesc}
                        dialogFooter={translations['ipmob.introduction.description_5']}
                        userType={userType}
                        isButtonDisabled={disableContinueButton}
                    />
                </div>
                <div className="trim-bg-image"/>
            </div>
        );
    }
}
